var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDublicateIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 6h-3V2.67A2.68 2.68 0 009.33 0H2.67A2.68 2.68 0 000 2.67v6.66A2.68 2.68 0 002.67 12H6v3a3 3 0 003 3h6a3 3 0 003-3V9a3 3 0 00-3-3zM6 9v1H2.67A.67.67 0 012 9.33V2.67A.67.67 0 012.67 2h6.66a.67.67 0 01.67.67V6H9a3 3 0 00-3 3z",
    fill: "#1D426D"
  })));
}

export default SvgDublicateIcon;